export const validExportReportTypes = {
  contact_report: 'contactSearch',
  property_report: 'propertySearch',
  detailed_person_report: 'peopleSearch',
  reverse_phone_report: 'phoneSearch',
  social_network_report: 'emailSearch',
  username_report: 'usernameSearch',
};

export const EXPORT_ENDPOINT = '/api/v5/export/reports';

export const potentialOwnerReports = [
  'reverse_phone_report',
  'social_network_report',
  'username_report',
];
